import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=524e48cb&scoped=true"
var script = {}
import style0 from "@/styles/not_found.scss?vue&type=style&index=0&id=524e48cb&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524e48cb",
  null
  
)

export default component.exports